export function shallowEqual<T extends object>(objA: T, objB: T): boolean {
    if (objA === objB) {
      return true;
    }

    if (objA === null || objB === null) {
      return false;
    }

    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);

    if (keysA.length !== keysB.length) {
      return false;
    }

    // Test for A"s keys different from B.
    const bHasOwnProperty = Object.hasOwnProperty.bind(objB);

    for (const key of keysA) {
        if (!bHasOwnProperty(key) || (objA as any)[key] !== (objB as any)[key]) {
            return false;
        }
    }

    return true;
}
